export const supportedLocales = [
  'de-AT',
  'de-DE',
  'en-AU',
  'en-CA',
  'en-GB',
  'en-HK',
  'en-IN',
  'en-NZ',
  'en-SG',
  'en-TH',
  'en-US',
  'en-XB',
  'es-AR',
  'es-ES',
  'es-MX',
  'fi-FI',
  'fr-CA',
  'fr-FR',
  'it-IT',
  'ja-JP',
  'nl-NL',
  'no-NO',
  'sv-SE',
  'th-TH',
  'zh-HK',
  'zh-TW',
  'he-IL',
  'nb-NO',
  'en-ZA',
  'ru-RU',
  'fr-CH',
];

export const supportedCountries = [
  {
    name: 'Argentina',
    locale: 'es-ar',
    products: ['the-platinum-card', 'the-centurion-card'],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Australia',
    locale: 'en-au',
    products: ['the-platinum-card', 'the-centurion-card'],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Austria',
    locale: 'de-at',
    products: ['the-platinum-card', 'the-centurion-card'],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Canada',
    locale: 'fr-ca',
    products: ['the-platinum-card', 'the-centurion-card'],
    showInCardPicker: true,
    multiLanguage: true,
  },
  {
    name: 'Canada',
    locale: 'en-ca',
    products: ['the-platinum-card', 'the-centurion-card'],
    showInCardPicker: true,
    multiLanguage: true,
  },
  {
    name: 'Finland',
    locale: 'fi-fi',
    products: ['the-platinum-card'],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'France',
    locale: 'fr-fr',
    products: ['the-platinum-card', 'the-centurion-card'],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Germany',
    locale: 'de-de',
    products: ['the-platinum-card', 'the-centurion-card'],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Hong Kong SAR',
    locale: 'en-hk',
    products: ['the-platinum-card', 'the-centurion-card'],
    showInCardPicker: true,
    multiLanguage: true,
  },
  {
    name: 'Hong Kong SAR',
    locale: 'zh-hk',
    products: ['the-platinum-card', 'the-centurion-card'],
    showInCardPicker: true,
    multiLanguage: true,
  },
  {
    name: 'India',
    locale: 'en-in',
    products: ['the-platinum-card', 'the-centurion-card'],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'International Currency Card',
    locale: 'en-xb',
    products: ['the-platinum-card', 'the-centurion-card'],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Italy',
    locale: 'it-it',
    products: ['the-platinum-card', 'the-centurion-card'],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Japan',
    locale: 'ja-jp',
    products: ['the-platinum-card', 'the-centurion-card'],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Mexico',
    locale: 'es-mx',
    products: ['the-platinum-card', 'the-centurion-card'],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'The Netherlands',
    locale: 'nl-nl',
    products: ['the-platinum-card', 'the-centurion-card'],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'New Zealand',
    locale: 'en-nz',
    products: ['the-platinum-card'],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Singapore',
    locale: 'en-sg',
    products: ['the-platinum-card', 'the-centurion-card'],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Spain',
    locale: 'es-es',
    products: ['the-platinum-card', 'the-centurion-card'],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Sweden',
    locale: 'sv-se',
    products: ['the-platinum-card', 'the-centurion-card'],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Taiwan',
    locale: 'zh-tw',
    products: ['the-platinum-card', 'the-centurion-card'],
    showInCardPicker: false,
    multiLanguage: false,
  },
  {
    name: 'Thailand',
    locale: 'en-th',
    products: ['the-platinum-card'],
    showInCardPicker: true,
    multiLanguage: true,
  },
  {
    name: 'United Kingdom',
    code: 'UK',
    locale: 'en-gb',
    products: ['the-platinum-card', 'the-centurion-card'],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'United States',
    code: 'US',
    locale: 'en-us',
    products: [
      'the-platinum-card',
      'the-platinum-card-idc-en',
      'the-platinum-card-idc-es',
      'delta-reserve',
      'the-centurion-card',
    ],
    showInCardPicker: true,
    multiLanguage: false,
  },
];
